import { WeightUnit } from "@api/graphql/generated/generated-types";

export const formatWeight = (weight: number, weightUnit: WeightUnit): string => {
  if (!Number.isFinite(weight)) {
    return "";
  }

  const label = weightUnit === WeightUnit.Kg ? "kg" : "lbs";
  return `${weight.toFixed(1)} ${label}`;
};
